import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./UniversitySubjectTable.css";

const UniversitySubjectTable = () => {
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [courses, setCourses] = useState([]);
  const [semesterId, setSemesterId] = useState("");
  const [semesters, setSemesters] = useState([]);
  const [universitySubjects, setUniversitySubjects] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => setUniversities(response.data?.data || []))
      .catch((error) => console.error("Error fetching universities:", error));
  }, [API_BASE_URL]);

  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => setCourses(response.data?.data || []))
        .catch((error) => console.error("Error fetching courses:", error));
    }
  }, [universityId, API_BASE_URL]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => setSemesters(response.data?.data || []))
      .catch((error) => console.error("Error fetching semesters:", error));
  }, [API_BASE_URL]);

  const getSubject = () => {
    if (courseId) {
      axios
        .get(
          `${API_BASE_URL}/college-subjects?courseId=${courseId}&semesterId=${semesterId}`
        )
        .then((response) => setUniversitySubjects(response.data?.data || []))
        .catch((error) => console.error("Error fetching subjects:", error));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    getSubject();
  };

  const handleUpdate = (id) => {
    navigate(`/university-subject-edit/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this subject?")) {
      axios
        .delete(`${API_BASE_URL}/college-subject/${id}`)
        .then(() => {
          alert("Subject deleted successfully!");
          setUniversitySubjects((prevSubjects) =>
            prevSubjects.filter((subject) => subject._id !== id)
          );
        })
        .catch((error) => console.error("Error deleting subject:", error));
    }
  };

  return (
    <div id="college-all-course-inner-main-wrapper">
      <div className="course-header-with-btns-table-page">
        <h5>All Subject</h5>
        <div className="college-all-course-nav-btns-table">
          <Link to={"/college-subject"}>
            <button className="college-add-course-add-btn-table-page">
              + Add New Subject
            </button>
          </Link>
          <Link to={"/college-all-subject"}>
            <button className="college-all-course-btn-table-page">
              All Subject
            </button>
          </Link>
        </div>
      </div>

      <div className="form-main-container">
        <h4 className="college-course-detail">Subject</h4>
        <form onSubmit={handleSubmit} className="college-course-detail-form">
          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Select University</label>
            <select
              className="new-chapter-dropdown"
              value={universityId}
              onChange={(e) => setUniversityId(e.target.value)}
              required
            >
              <option value="">-Select University-</option>
              {universities.map((university, idx) => (
                <option key={idx} value={university._id}>
                  {university.universityName}
                </option>
              ))}
            </select>
          </div>
          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Course Name</label>
            <select
              className="new-chapter-dropdown"
              value={courseId}
              onChange={(e) => setCourseId(e.target.value)}
              required
            >
              <option value="">-Select Course-</option>
              {courses.map((course, idx) => (
                <option key={idx} value={course._id}>
                  {course.courseName}
                </option>
              ))}
            </select>
          </div>
          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Semester</label>
            <select
              className="new-chapter-dropdown"
              value={semesterId}
              onChange={(e) => setSemesterId(e.target.value)}
              required
            >
              <option value="">-Select Semester-</option>
              {semesters.map((semester, idx) => (
                <option key={idx} value={semester._id}>
                  {semester.semesterName}
                </option>
              ))}
            </select>
          </div>
          <div className="college-course-form-btns">
            <button className="btn-search" type="submit">
              Search Subject
            </button>
          </div>
        </form>
      </div>

      {universitySubjects.length > 0 && (
        <div className="headertable">
          <h5>All College Subject</h5>
          <table>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Subject Name</th>
                <th>Category</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {universitySubjects.map((universitySubject, idx) => (
                <tr
                  key={idx}
                  style={{
                    borderBottom: "1px solid #0b0909ff",
                  }}
                >
                  <td>{idx + 1}</td>
                  <td>{universitySubject.subjectName}</td>
                  <td>{universitySubject.category.join(", ")}</td>
                  <td
                    style={{
                      display: "flex",
                      gap: "5px",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px 0",
                    }}
                  >
                    <button
                      onClick={() => handleUpdate(universitySubject._id)}
                      aria-label="Edit subject"
                      style={{
                        cursor: "pointer",
                        border: "none",
                        background: "none",
                      }}
                    >
                      <i className="fa-solid fa-file-pen"></i>
                    </button>
                    <button
                      onClick={() => handleDelete(universitySubject._id)}
                      aria-label="Delete subject"
                      style={{
                        cursor: "pointer",
                        border: "none",
                        background: "none",
                      }}
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UniversitySubjectTable;
